import {
  Alert,
  ContentLayout,
  Header,
} from '@cloudscape-design/components';
import {
  getPLCUrl,
  getPressTitle,
  normalizePressId,
} from 'features/plc/contracts/machines';
import {
  PLC_PATHS,
  PRESS_HMI_GROUPS,
} from 'features/plc/contracts/pressHMI.schema';
import HMIHandleProvider from 'features/plc/providers/HMIHandleProvider';
import React from 'react';
import { useParams } from 'react-router-dom';

import HMIRouter from './router';

function PressHMIPage() {
  const { pressId } = useParams();
  const plcUrl = getPLCUrl(pressId);

  if (!plcUrl) {
    const pageTitle = getPressTitle(pressId) || pressId;
    return (
      <ContentLayout header={<Header variant="h1">{pageTitle}</Header>}>
        <Alert type="error" header="Unsupported press">
          No PLC endpoint is configured for
          {' '}
          <strong>{pageTitle}</strong>
          .
        </Alert>
      </ContentLayout>
    );
  }

  return (
    <HMIHandleProvider
      plcUrl={plcUrl}
      pressId={normalizePressId(pressId)}
      groupsMap={PRESS_HMI_GROUPS}
      debugPaths={PLC_PATHS}
      test={process.env.REACT_APP_ENV !== 'production'}
    >
      <HMIRouter />
    </HMIHandleProvider>
  );
}

export default PressHMIPage;
